import Amount from '@components/common/molecules/Amount';
import FoodPrice from '@components/offer/models/FoodPrice';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface FoodPriceListItemProps {
    foodPrice: FoodPrice;
}

const FoodPriceListItem: React.FC<FoodPriceListItemProps> = observer(({ foodPrice }) => {
    return (
        <Amount
            amount={foodPrice.price}
            variant='subtitle2'
            color={(theme) => theme.palette.secondary.main}
            fontWeight={600}
            lineHeight={1.2} />
    )
})

export default FoodPriceListItem;